const SET_CURRENT_STEP = 'SET_CURRENT_STEP';

const SET_FROM_DATE = 'SET_FROM_DATE';
const SET_FROM_DATE_END = 'SET_FROM_DATE_END';
const SET_TO_DATE = 'SET_TO_DATE';
const SET_TO_DATE_END = 'SET_TO_DATE_END';
const SET_ACTIVITY_TYPES = 'SET_ACTIVITY_TYPES';
const SET_DIRECTIONS_OPS = 'SET_DIRECTIONS_OPS';
const SET_HUBS_OPS = 'SET_HUBS_OPS';
const SET_COLLABORATORS = 'SET_COLLABORATORS';
const SET_AUDITED_CUSTOMERS = 'SET_AUDITED_CUSTOMERS';
const SET_REFERENTIALS = 'SET_REFERENTIALS';

const SET_CHARGES_ID_SELECTED = 'SET_CHARGES_ID_SELECTED';
const SET_CHARGES_SELECTED = 'SET_CHARGES_SELECTED';
const SET_OPTIONS_FROM_DATE = 'SET_OPTIONS_FROM_DATE';
const SET_OPTIONS_VOLUME_CHANGE = 'SET_OPTIONS_VOLUME_CHANGE';
const SET_OPTIONS_VOLUME_RATIO = 'SET_OPTIONS_VOLUME_RATIO';
const SET_OPTIONS_KEEP_ACTIVITIES = 'SET_OPTIONS_KEEP_ACTIVITIES';
const SET_OPTIONS_KEEP_COLLABORATOR = 'SET_OPTIONS_KEEP_COLLABORATOR';

const REDUCER_ACTIONS = {
  SET_CURRENT_STEP,

  SET_FROM_DATE,
  SET_FROM_DATE_END,
  SET_TO_DATE,
  SET_TO_DATE_END,
  SET_ACTIVITY_TYPES,
  SET_DIRECTIONS_OPS,
  SET_HUBS_OPS,
  SET_COLLABORATORS,
  SET_AUDITED_CUSTOMERS,
  SET_REFERENTIALS,

  SET_CHARGES_ID_SELECTED,
  SET_CHARGES_SELECTED,
  SET_OPTIONS_FROM_DATE,
  SET_OPTIONS_VOLUME_CHANGE,
  SET_OPTIONS_VOLUME_RATIO,
  SET_OPTIONS_KEEP_ACTIVITIES,
  SET_OPTIONS_KEEP_COLLABORATOR,
}
export default REDUCER_ACTIONS;
